export const SEPARATOR = ",";
export const NEW_LINE = "\n";
export const addBulkUsersMandatoryFields = [
  "email",
  "firstName",
  "lastName",
  "authMethod",
  "roles",
  "groups",
] as const;

const exampleUsers = [
  [
    "harry_potter@mail.com",
    "Harry",
    "Potter",
    "CREDENTIALS",
    '"UPS:Admin"',
    '"HR, Group Alpha"',
  ],
  [
    "ron_weasley@mail.com",
    "Ron",
    "Weasley",
    "AUTH_CODE",
    '"UPS:User"',
    '"Developers, HR"',
  ],
];

const addBulkUserTemplateBlob = new Blob(
  [
    addBulkUsersMandatoryFields.join(SEPARATOR) +
      NEW_LINE +
      exampleUsers.map((user) => user.join(SEPARATOR)).join(NEW_LINE),
  ],
  { type: "text/csv" },
);
export const addBulkUserTemplateUrl = URL.createObjectURL(
  addBulkUserTemplateBlob,
);
